import { Box } from "@chakra-ui/react"
import ThemeBackground from "@pathwright/ui/src/components/background/ThemeBackground"
import PortableFullscreen from "@pathwright/ui/src/components/fullscreen/PortableFullscreen"
import useWindowSize from "@pathwright/ui/src/components/hooks/useWindowSize"
import { usePortableContext } from "@pathwright/ui/src/components/portable/Portable"
import { ToggleIntercomUI } from "@pathwright/web/src/modules/intercom/IntercomProvider"
import { AnimatePresence, motion } from "framer-motion"
import { useEffect } from "react"
import { createGlobalStyle } from "styled-components"
import ChangelogIframe from "./ChangelogIframe"

const GlobalChangelogStyles = createGlobalStyle`
  .loading-splash {
    display: none;
  }
`

const transition = {
  type: "spring",
  stiffness: 180, // stiffneess is how much it resists the spring
  damping: 24 // damping is how much it wobbles
}

const useWidth = () => {
  const size = useWindowSize()
  const minW = size.width >= 1000 ? Math.min(400, size.width) : size.width
  const width = Math.max(minW, 400)
  return width
}

function Changelog({ closing, onClose, onCloseEnd, ...rest }) {
  let padding = 10

  const { setPorting } = usePortableContext()
  const width = useWidth()
  const fullscreen = width === window.innerWidth

  // Avoid animating the width property when in fullscreen.
  const motionProps = fullscreen
    ? {
        initial: { opacity: 0 },
        animate: { opacity: 1, transition },
        exit: { opacity: 0, transition }
      }
    : {
        initial: { opacity: 0, width: 0 },
        animate: { opacity: 1, width, transition },
        exit: { opacity: 0, width: 0, transition }
      }

  useEffect(() => {
    setPorting(fullscreen)
  }, [fullscreen])

  return (
    <>
      <GlobalChangelogStyles />
      <AnimatePresence>
        {!closing && (
          <ToggleIntercomUI>
            <Box
              as={motion.div}
              key="changelog-augmentation"
              h="100vh"
              // Overriding framer motions animtation on width when in fullscreen.
              w={fullscreen ? `${width}px !important` : `${width}px`}
              flexGrow="1"
              flexShrink="0"
              position="relative"
              onAnimationComplete={onCloseEnd}
              {...motionProps}
              {...rest}
            >
              {fullscreen && <ThemeBackground />}
              <ChangelogIframe onClose={onClose} inset={`${padding}px`} />
            </Box>
          </ToggleIntercomUI>
        )}
      </AnimatePresence>
    </>
  )
}

function ChangelogContainer(props) {
  // The basic idea behind using the reverse portal is that changing screen width sizes
  // won't result in a unmount/remount, but there is an inherent quality in iframes
  // the will always result in a reload when moved in the DOM, so not much gained.
  // See: https://github.com/httptoolkit/react-reverse-portal/issues/14
  return (
    <PortableFullscreen showIcons={false}>
      <Changelog {...props} />
    </PortableFullscreen>
  )
}

export default ChangelogContainer
